import type { UserFullInfo, UserPublicProfile } from '@/client/types.gen'

/**
 * True when the API returned a full profile (includes email and other PII fields).
 * Same-company peers receive {@link UserPublicProfile} only.
 */
export function isUserFullInfo(user: UserFullInfo | UserPublicProfile): user is UserFullInfo {
	return 'email' in user
}

/** Display name: full name, else email (full profile), else empty. */
export function getUserDisplayName(user: UserFullInfo | UserPublicProfile): string {
	const full = `${user.firstname} ${user.lastname}`.trim()
	if (full) return full
	if (isUserFullInfo(user)) return user.email
	return ''
}

/** Label sent with WebSocket presence subscriptions for the current user. */
export function getPresenceDisplayName(
	user:
		| {
				firstname?: string | null
				lastname?: string | null
				email?: string | null
				id?: string
		  }
		| null
		| undefined
): string {
	if (!user) return ''
	const full = `${user.firstname ?? ''} ${user.lastname ?? ''}`.trim()
	if (full) return full
	if (user.email) return user.email
	if (user.id) return `User ${user.id.slice(0, 8)}`
	return ''
}

/** Secondary line for lists (e.g. email); omitted for public profiles. */
export function getUserSecondaryLine(user: UserFullInfo | UserPublicProfile): string | undefined {
	if (isUserFullInfo(user)) return user.email
	return undefined
}
